import { Row, Col } from "react-bootstrap";
import HomeDashboard from "../../components/home-dashboard";
import HomeAnnouncements from "../../components/home-announcements";
import LoggedInLayout from "../../layouts/loggedin-layout";
import { useEffect } from "react";

const HomePage = () => {
    useEffect(() => {
        document.title = "MFP - Home";
    },[])

    return (
        <LoggedInLayout>
            <Row>
                <Col xs={12}>
                    <HomeAnnouncements />
                </Col>
            </Row>
            <HomeDashboard />
        </LoggedInLayout>
    );
};

export default HomePage;
